import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["label", "input", "zone"];

  connect() {
    this.defaultText = this.labelTarget.textContent;
    this.boundDragover = this.dragover.bind(this);
    this.boundDragleave = this.dragleave.bind(this);
    this.boundDrop = this.drop.bind(this);
    this.zoneTarget.addEventListener("dragover", this.boundDragover);
    this.zoneTarget.addEventListener("dragleave", this.boundDragleave);
    this.zoneTarget.addEventListener("drop", this.boundDrop);
  }

  disconnect() {
    if (!this.hasZoneTarget) return;
    this.zoneTarget.removeEventListener("dragover", this.boundDragover);
    this.zoneTarget.removeEventListener("dragleave", this.boundDragleave);
    this.zoneTarget.removeEventListener("drop", this.boundDrop);
  }

  dragover(e) {
    e.preventDefault();
    e.currentTarget.classList.add("border-primary", "bg-primary-faint");
  }

  dragleave(e) {
    e.preventDefault();
    e.currentTarget.classList.remove("border-primary", "bg-primary-faint");
  }

  drop(e) {
    e.preventDefault();
    e.currentTarget.classList.remove("border-primary", "bg-primary-faint");
    const files = e.dataTransfer?.files;
    if (files?.length > 0) {
      const dt = new DataTransfer();
      dt.items.add(files[0]);
      this.inputTarget.files = dt.files;
      this.updateLabel();
    }
  }

  updateLabel() {
    const input = this.inputTarget;
    const labelEl = this.labelTarget;

    if (input.files?.length > 0) {
      labelEl.textContent = input.files[0].name;
      labelEl.classList.add("text-primary");
      labelEl.classList.remove("text-gray-600");
    } else {
      labelEl.textContent = this.defaultText || "Video auswählen oder hier ablegen";
      labelEl.classList.remove("text-primary");
      labelEl.classList.add("text-gray-600");
    }
  }
}
